import React from 'react';
import PropTypes from 'prop-types';

// Components
import RefHeader from './RefHeader';
import WidgetDescription from './WidgetDescription';
import WidgetHelper from './WidgetHelper';
import WidgetOptions from './WidgetOptions';
import WidgetMethods from './WidgetMethods';
import WidgetEvents from './WidgetEvents';
import NotFound from '../NotFound';
import CategoryDropdownContainer from './containers/CategoryDropdownContainer';
import { categoryWidgets } from './CategoryWidgetList';

// Presentational Component
class WidgetReference extends React.PureComponent {

	// Highlight HTML snippets
	componentDidMount() {
		if (window.Prism) { window.Prism.highlightAll() }
	}
	componentDidUpdate() {
		if (window.Prism) { window.Prism.highlightAll() }
	}
	shouldComponentUpdate(nextProps) {
		return this.props.widget.name !== nextProps.widget.name;
	}

	render() {
		var { widget, widgets } = this.props;
		if (!widget) { return <NotFound /> }
		return (
			<div className="widget-reference">
				<RefHeader />
				<h2>{widget.name}</h2>
				<div className='responsive-small'>
					<CategoryDropdownContainer widgets={categoryWidgets(widgets, widget.category)} />
				</div>
				<p>
					<WidgetDescription desc={widget.summary} />
					{widget.helper &&
						<WidgetHelper helperName={widget.helper} />
					}
				</p>
				{widget.hasImage &&
					<img src={`${process.env.PUBLIC_URL}/img/widgets/${widget.name}.png`} alt="Widget sample" />
				}
				<WidgetOptions widget={widget} />
				<WidgetMethods widgetName={widget.name} />
				<WidgetEvents widget={widget} />
			</div>
		);
	}
}

WidgetReference.propTypes = {
	widget: PropTypes.object.isRequired,
	widgets: PropTypes.object.isRequired
};

export default WidgetReference;



// WEBPACK FOOTER //
// ./src/components/widgets/WidgetReference.js